import { Logger } from '@kulee/helper'

// 日志前缀
export const LOGGER_PREFIX = '__CLAZZ__'
// 日志输出等级
export const LOGGER_LEVEL = Logger.LEVEL.INFO

// 返回的错误码
export const RESPONSE_CODES = {
  // 广告初始化错误
  AD_INIT_ERROR: 'AD/INIT_ERROR'
}
